export const UPDATE_USER_DATA = (state, val) => {
  state.userAccount = { ...state.user, ...val.account };
};

export const UPDATE_BILLING_DATA = (state, val) => {
  state.billingData = val;
};

export const CARDS_REQUEST_DISPATCH = (state) => {
  state.cards.status = 'requested';
};

export const CARDS_REQUEST_SUCCESS = (state) => {
  state.cards.status = 'success';
};

export const CARDS_REQUEST_ERROR = (state) => {
  state.cards.status = 'error';
};

export const SAVE_FWD_ADDR_LIST = (state, val) => {
  state.fwdAddrList = val;
}

export const SAVE_SMS_SERVICE_PARAMS = (state, val) => {
  state.smsService = val.sms_service;
}

export const SAVE_USER_STATS = (state, val) => {
  state.userStats = val.stats;
}

export const SAVE_JOINT_ACCOUNTS = (state, val) => {
  state.jointAccounts = val.joint_accounts;
}

export const ADD_JOINT_ACCOUNT = (state, val) => {
  state.jointAccounts.push(val.joint_account);
}

export const UPDATE_JOINT_ACCOUNT = (state, val) => {
  let index = state.jointAccounts.findIndex(acc => acc.id == val.id);

  state.jointAccounts[index] = val;
}

export const REMOVE_JOINT_ACCOUNT = (state, val) => {
  state.jointAccounts = state.jointAccounts.filter(acc => acc.id !== val);
}

export const SAVE_NOTARIZE_LIST = (state, val) => {
  state.notarizeList = val.notary_packages;
}

export const SAVE_PHONE_LIST = (state, val) => {
  state.phoneList = val.phone_numbers;
}

export const SAVE_USER_PLAN = (state, val) => {
  state.userPlan = val.plan;
}

export const SAVE_FORM1583_STATUS = (state, val) => {
  state.form1583Signed = val;
}

export const SAVE_ACCOUNT_DOCUMENT = (state, val) => {
  let documents = [...state.userAccount.documents]
  let index = documents.findIndex(item => item.document_type_id == val.document_type_id);

  documents[index] = val;
  state.userAccount.documents = documents;
}

